import {Container, IFrame} from './YouTubeEmbed.styles';


const YoutubeEmbed = ({ embedId }) => (
  <Container>
    <IFrame
      width="853"
      height="480"
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </Container>
);

export default YoutubeEmbed;